const common_product_pro = (viewmodel) => {
  viewmodel.get('orderNum').setState('min', 0)
  let gridModel = viewmodel.getGridModel();
  let gridModelData = null;
  let userdefinesModel = viewmodel.get('userdefines');
  userdefinesModel.on("afterSetActionsState", function (states) {
    let mode = viewmodel.getParams().mode;
    if (mode == 'browse') {
      states.map(val => val.cmdeleteRow.visible = false)
    } else {
      states.map(val => val.cmdeleteRow.visible = true)
    }
  });
  userdefinesModel.on('beforeCellValueChange', function (args) {
    let _value = args.value;
    if (args.cellName === 'name' && !!_value && _value.includes(';')) {
      cb.utils.alert('名称中禁止输入分号');
      let _newValue = args.value.replace(/[;；]/g, '');
      _userdefines.setCellValue(args.rowIndex, args.cellName, _newValue);
      return false
    }
  })
  //
  const diffArchive = () => {
    let _userdefModeData = Number(viewmodel.get('userdefMode').getValue());
    let type = viewmodel.get('type').getValue();
    let val =  (type==="Enum" || (_userdefModeData === 0 || _userdefModeData === 3)) ? true : false //0 输入项 隐藏
    if (val) {
      gridModelData = gridModel.getData()
      gridModel.clear()
    } else {
      gridModel.batchInsertRow(gridModelData)
    }
  }
  // 只改类型
  const diffArchiveType = () => {
    let _userdefModeData = Number(viewmodel.get('userdefMode').getValue());
    let type = viewmodel.get('type').getValue();
    let val =  (type==="Enum" || (_userdefModeData === 0 || _userdefModeData === 3)) ? true : false //0 输入项 隐藏
    let mode = viewmodel.getParams().mode;
    if (mode == 'browse') { //btnAddRow 新增值
      viewmodel.get('btnAddRow').setVisible(false); // 浏览态下隐藏
    } else {
      viewmodel.get('btnAddRow').setVisible(!val); // 按钮隐藏
    }
    viewmodel.getGridModel("userdefines").setVisible(val); // userdefines 下面表格隐藏
  }

  const diffSourcetype = () => {
    let sourcetypeModel = viewmodel.get('sourcetype')
    let sourcetypeData = sourcetypeModel.getValue();
    let val = typeof sourcetypeData == 'boolean' ? sourcetypeData : (sourcetypeData == 'false' || sourcetypeData == '' || sourcetypeData == undefined ? false : true)
    viewmodel.get('showItem').setDisabled(val);
    if (!val) sourcetypeModel.setValue('false')
    sourcetypeModel.setDisabled(true)
  }
  // 枚举显示隐藏
const _difftype = ()=>{
    let val = viewmodel.get('type').getValue()
    let userdefModemodel = viewmodel.get('userdefMode'); // 录入方式
    userdefModemodel.setDisabled(val != 'String')
    let _maxInputLen = viewmodel.get('maxInputLen')
    let _decimalDigits = viewmodel.get('decimalDigits')
    _maxInputLen.setState("min", 1);
    _maxInputLen.setState("max", 255);
    // 枚举
    let enumNameModel = viewmodel.get('enumId_name'); // 枚举项
    let enumCodeModel = viewmodel.get('enumId'); // 枚举项code
    enumNameModel.setState('bIsNull', !(val==="Enum"));
    enumNameModel.setDisabled(!(val==="Enum"));
    switch (val) {
      case 'String': //字符串
        _maxInputLen.setDisabled(false)
        _maxInputLen.setState('bIsNull', false);
        _decimalDigits.setDisabled(true)
        break;
      case 'Integer': //整形
        _maxInputLen.setDisabled(false)
        _maxInputLen.setState('bIsNull', false);
        _decimalDigits.setDisabled(true)
        break;
      case 'Double': //数值
        _maxInputLen.setDisabled(false)
        _maxInputLen.setState('bIsNull', false);
        _decimalDigits.setDisabled(false)
        _decimalDigits.setState("min", 0);
        _decimalDigits.setState("max", 8);
        break;
      case "Enum":
      userdefModemodel.setValue(1);
      default:
        _maxInputLen.setDisabled(true)
        _maxInputLen.setState('bIsNull', true);
        _decimalDigits.setDisabled(true)
    }
}
  const difftype = () => {
    let val = viewmodel.get('type').getValue()
    let userdefModemodel = viewmodel.get('userdefMode'); // 录入方式
    if (val != 'String') {
      userdefModemodel.setValue('0')
      userdefModemodel.setDisabled(true)
    } else {
      userdefModemodel.setDisabled(false)
    }
    let _maxInputLen = viewmodel.get('maxInputLen')
    let _decimalDigits = viewmodel.get('decimalDigits')
    _maxInputLen.setState("min", 1);
    _maxInputLen.setState("max", 255);
    // 枚举
    let enumNameModel = viewmodel.get('enumId_name'); // 枚举项
    let enumCodeModel = viewmodel.get('enumId'); // 枚举项code
    enumNameModel.setState('bIsNull', !(val==="Enum"));
    enumNameModel.setDisabled(!(val==="Enum"));
    enumNameModel.setValue(null);
    enumCodeModel.setValue(null);
    userdefModemodel.setValue(0);
    switch (val) {
      case 'String': //字符串
        _maxInputLen.setDisabled(false)
        _maxInputLen.setState('bIsNull', false);
        _decimalDigits.setDisabled(true)
        _decimalDigits.setValue(null)
        break;
      case 'Integer': //整形
        _maxInputLen.setDisabled(false)
        _maxInputLen.setState('bIsNull', false);
        _decimalDigits.setDisabled(true)
        _decimalDigits.setValue(null)
        break;
      case 'Double': //数值
        _maxInputLen.setDisabled(false)
        _maxInputLen.setState('bIsNull', false);
        _decimalDigits.setDisabled(false)
        _decimalDigits.setState("min", 0);
        _decimalDigits.setState("max", 8);
        break;
      case "Enum":
      userdefModemodel.setValue(1);
      default:
        _maxInputLen.setDisabled(true)
        _maxInputLen.setState('bIsNull', true);
        _maxInputLen.setValue(null)
        _decimalDigits.setDisabled(true)
        _decimalDigits.setValue(null)
    }
  }
  viewmodel.get('userdefMode').on('afterValueChange', (args) => {
    if(args.async===false) return
    diffArchive()
    diffArchiveType()
  })
  viewmodel.get('type').on('afterValueChange', (args) => {
    if(args.async===false) return
    difftype()
    diffArchive()
    diffArchiveType()
  })
  viewmodel.get('enumId_name').on('afterValueChange', (argus) => {
    if(args.async===false) return
    let maxInputLen = viewmodel.get('maxInputLen').getValue();
    if(maxInputLen==null) {
      viewmodel.get('maxInputLen').setValue(255);
    }
  })
  viewmodel.on('afterEdit', () => {
    _difftype()
    diffArchiveType()
    diffdisabled()
  })
  const diffdisabled = () => {
    // 如果被引用 则设置不可编辑
    let _args = viewmodel.getAllData();
    let disabledArr = ['type', 'userdefMode',"enumId_name"]
    let mode = viewmodel.getParams().mode;
    if (mode != 'add') {
      if (_args.checkPro.checkHead == 1) {
        disabledArr.forEach(val => {
          viewmodel.get(val).setDisabled(true)
        })
      }
      let gridModel = viewmodel.getGridModel()
      if (_args.checkPro.checkBody.length) {
        let _data = viewmodel.get('userdefines').getData()
        _data.forEach((val, index) => {
          if (_args.checkPro.checkBody.indexOf(val.id) >= 0) {
            gridModel.setRowState(index, 'disabled', true)
          }
        })
      }
    }
  }
  viewmodel.on('beforeSave', (args) => {
    var data = JSON.parse(args.data.data);
    if(data.type==="Enum"){
      data.userdefMode = 0
    }
    if (data.type == "Double" && !data.decimalDigits) {
      data.decimalDigits = 0
    }
    args.data.data = JSON.stringify(data);
  })
  viewmodel.on('afterLoadData', function () {
    let mode = viewmodel.getParams().mode
    if (mode == 'add') {
      _difftype()
      diffdisabled()
      diffArchiveType()
    }
    if(mode =="browse"){
      setTimeout(() => { // 枚举项
        let type = viewmodel.get('type').getValue();
        if(type==="Enum"){
          viewmodel.get('userdefMode').setValue(1)
        }
      }, 20);
      diffArchiveType()
    }
    // 初始状态 录入方式 为 档案 时显示，不为 档案 隐藏
    gridModelData = gridModel.getData();
    diffSourcetype()
    let _typeValue = viewmodel.get('type').getValue();
    let userdefModemodel = viewmodel.get('userdefMode')
    if (_typeValue != 'String') {
      userdefModemodel.setValue('0')
      userdefModemodel.setDisabled(true)
    } else {
      userdefModemodel.setDisabled(false)
    }
  })
}
export default common_product_pro



// WEBPACK FOOTER //
// ./src/client/business/PC/common_product_pro.js